export const PRODUCTION_ORDERS_DETAILS_TABS = {
  PRODUCTION_LOTS: 'production-lots',
  WORK_TIME: 'work-time',
  RAW_MATERIALS: 'raw-materials',
};
